import gaParams from '../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../utilities/analytics/tracking';
import {otpValidationPopupContent, customerTypeEnum, lobbyTabsEnum, searchParametersEnum, pages} from './cellcomAbroadVariables';

export function gAAbroadLobbyIsLoaded(tabName) {
  gtag4({
    event: 'CellcomAbroad_Step1_LobbyPage',
    step: '1',
    action: 'LobbyPage',
    process_type: 'private',
    funnel_name: '1 - Lobby',
  });
}

export function gAAbroadBusinessIndividualLobbyIsLoaded() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PARAMETERS_VIEW_ACCOUNT_SELECTED.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PARAMETERS_VIEW_ACCOUNT_SELECTED.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PARAMETERS_VIEW_ACCOUNT_SELECTED.eventParams,
  );
}

export function selectAccountStickyFooterBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_SELECT_ACCOUNT_STICKY_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_SELECT_ACCOUNT_STICKY_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_SELECT_ACCOUNT_STICKY_BUTTON_CLICK.eventParams,
  );
}
export function gaChangeAccountBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_CHANGE_SELECTED_ACCOUNT_BUTTON_CLICK.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_CHANGE_SELECTED_ACCOUNT_BUTTON_CLICK.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_CHANGE_SELECTED_ACCOUNT_BUTTON_CLICK.eventParams,
  );
}
export function gaSelectCountriesTabIsClicked(activeLobbyTab, isSeparatedSale) {
  switch (activeLobbyTab) {
    case lobbyTabsEnum.PRIVATE:
      gaEvent(
        gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_PRIVATE.category,
        gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_PRIVATE.eventType,
        gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_PRIVATE.eventParams,
      );
      break;
    case lobbyTabsEnum.BUSINESSACCOUNT:
      if (isSeparatedSale) {
        gaEvent(
          gaParams.SEPARATED_COUNTRYDEFINITION_CLICK.category,
          gaParams.SEPARATED_COUNTRYDEFINITION_CLICK.eventType,
          gaParams.SEPARATED_COUNTRYDEFINITION_CLICK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_BUSINESS.category,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED_BUSINESS.eventParams,
        );
      }
      break;
    default:
      break;
  }
}

export function gaSelectCountriesTabIsClickedBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_CLICKED.eventParams,
  );
}
export function selectParametersGAReport({
  activeLobbyTab,
  searchParameter,
  startedFromPackage,
  isSeparatedSale,
  isBusinessIndividual,
  selectedPackage,
}) {
  if (isBusinessIndividual) {
    if (searchParameter == searchParametersEnum.COUNTRY) {
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED.eventParams,
      );
    } else if (searchParameter == searchParametersEnum.DATES) {
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_OPENED.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_OPENED.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_OPENED.eventParams,
      );
    }
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (searchParameter == searchParametersEnum.COUNTRY) {
          if (startedFromPackage) {
            gtag4({
              event: 'CellcomAbroad_Step1_PackageClick',
              button: selectedPackage?.buttonValue,
              package_name: selectedPackage?.titleEpi,
              badge: selectedPackage?.tagTextSecondary,
              title: selectedPackage?.titleEpi,
              content: selectedPackage?.textUnderPackage,
              step: '1',
              action: 'PackageClick',
              process_type: 'private',
              funnel_name: '3 - Package',
            });
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_PRIVATE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_PRIVATE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_PRIVATE.eventParams,
            );
          }
        } else if (searchParameter == searchParametersEnum.DATES) {
          if (startedFromPackage) {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE_FROM_PACKAGE.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_PRIVATE.eventParams,
            );
          }
        }
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (searchParameter == searchParametersEnum.COUNTRY) {
          if (startedFromPackage) {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONS_SHOW.category,
                gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONS_SHOW.eventType,
                gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONS_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.eventParams,
              );
            }
          } else {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_COUNTRYDESTINATIONS_SHOW.category,
                gaParams.SEPARATED_COUNTRYDESTINATIONS_SHOW.eventType,
                gaParams.SEPARATED_COUNTRYDESTINATIONS_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS.category,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS.eventType,
                gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_IS_OPENED_BUSINESS.eventParams,
              );
            }
          }
        } else if (searchParameter == searchParametersEnum.DATES) {
          if (startedFromPackage) {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_FROMPACKAGECHOOSEDATES_SHOW.category,
                gaParams.SEPARATED_FROMPACKAGECHOOSEDATES_SHOW.eventType,
                gaParams.SEPARATED_FROMPACKAGECHOOSEDATES_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.category,
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.eventType,
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS_FROM_PACKAGE.eventParams,
              );
            }
          } else {
            if (isSeparatedSale) {
              gaEvent(
                gaParams.SEPARATED_CHOOSEDATES_SHOW.category,
                gaParams.SEPARATED_CHOOSEDATES_SHOW.eventType,
                gaParams.SEPARATED_CHOOSEDATES_SHOW.eventParams,
              );
            } else {
              gaEvent(
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS.category,
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS.eventType,
                gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_OPENED_BUSINESS.eventParams,
              );
            }
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaOnClosingSelectParametersTab(isSeparatedSale, startedFromPackage, isBusinessIndividual, parameterName) {
  if (isSeparatedSale) {
    if (parameterName == 'dates') {
      if (startedFromPackage) {
        gaEvent(
          gaParams.SEPARATED_FROMPACKAGEX_CLICK.category,
          gaParams.SEPARATED_FROMPACKAGEX_CLICK.eventType,
          gaParams.SEPARATED_FROMPACKAGEX_CLICK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.SEPARATED_XCLOSE_CLICK.category,
          gaParams.SEPARATED_XCLOSE_CLICK.eventType,
          gaParams.SEPARATED_XCLOSE_CLICK.eventParams,
        );
      }
    } else if (parameterName == 'countries') {
    }
  } else if (isBusinessIndividual) {
    if (parameterName == 'countries') {
      gaEvent(
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_CLOSE_SELECT_COUNTRIES_BUTTON_CLICK.category,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_CLOSE_SELECT_COUNTRIES_BUTTON_CLICK.eventType,
        gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_CLOSE_SELECT_COUNTRIES_BUTTON_CLICK.eventParams,
      );
    } else {
    }
  }
}

export function gaReportSelectingPopularCountry(activeLobbyTab, startedFromPackage, country, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY.eventType,
      country.countryHebName,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE_FROM_PACKAGE.eventType,
            country.countryHebName,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_PRIVATE.eventType,
            country.countryHebName,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONPOPULAR_CLICK.category,
              gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONPOPULAR_CLICK.eventType,
              country.countryHebName,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS_FROM_PACKAGE.eventType,
              country.countryHebName,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_POPULARDESTINATIONCHOOSE_CLICK.category,
              gaParams.SEPARATED_POPULARDESTINATIONCHOOSE_CLICK.eventType,
              country.countryHebName,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_POPULAR_COUNTRY_BUSINESS.eventType,
              country.countryHebName,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaSelectFromSearchedCountries(activeLobbyTab, startedFromPackage, isSeparatedSale, country, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY.eventType,
      country.countryHebName,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE_FROM_PACKAGE.eventType,
            country.countryHebName,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_PRIVATE.eventType,
            country.countryHebName,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONSEARCH_CLICK.category,
              gaParams.SEPARATED_FROMPACKAGECHOOSEDESTINATIONSEARCH_CLICK.eventType,
              country.countryHebName,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS_FROM_PACKAGE.eventType,
              country.countryHebName,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_SEARCHDESTINATIONCHOOSE_CLICK.category,
              gaParams.SEPARATED_SEARCHDESTINATIONCHOOSE_CLICK.eventType,
              country.countryHebName,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_SELECT_SEARCHED_COUNTRY_BUSINESS.eventType,
              country.countryHebName,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaSelectedCountriesList(
  activeLobbyTab,
  startedFromPackage,
  isSeparatedSale,
  listOfSelectedCountries,
  isBusinessIndividual,
) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED.eventType,
      listOfSelectedCountries,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step2_ContinueButtonClick',
            step: '2',
            action: 'ContinueButtonClick',
            process_type: 'private',
            funnel_name: '3 - Package',
            button: 'המשך',
          });
        } else {
          gtag4({
            event: 'CellcomAbroad_Step2_ContinueButtonClick',
            step: '2',
            action: 'ContinueButtonClick',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
            button: 'המשך',
          });
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGEDESTINATIONSCONTINUE_CLICK.category,
              gaParams.SEPARATED_FROMPACKAGEDESTINATIONSCONTINUE_CLICK.eventType,
              listOfSelectedCountries,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS_FROM_PACKAGE.eventType,
              listOfSelectedCountries,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_DESTINATIONCONTINUE_CLICK.category,
              gaParams.SEPARATED_DESTINATIONCONTINUE_CLICK.eventType,
              listOfSelectedCountries,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_CONTINUE_BUTTON_IS_CLICKED_BUSINESS.eventType,
              listOfSelectedCountries,
            );
          }
        }

        break;
      default:
        break;
    }
  }
}

export function gaSelectConnectedCountry(activeLobbyTab, startedFromPackage, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP.eventParams,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_PRIVATE.eventParams,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGEADD_CLICK.category,
              gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGEADD_CLICK.eventType,
              gaParams.SEPARATED_FROMPACKAGEDESTINATIONADDITIONMESSAGEADD_CLICK.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS_FROM_PACKAGE.eventParams,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_ADDDESTINATION_CLICK.category,
              gaParams.SEPARATED_ADDDESTINATION_CLICK.eventType,
              gaParams.SEPARATED_ADDDESTINATION_CLICK.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.eventType,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ADD_COUNTRY_FROM_CONNECTED_COUNTRY_EXISTS_POPUP_BUSINESS.eventParams,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaCountryNotFound(activeLobbyTab, startedFromPackage, searchValue, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY.eventType,
      searchValue,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (activeLobbyTab) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE_FROM_PACKAGE.eventType,
            searchValue,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_PRIVATE.eventType,
            searchValue,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGENODESTINATIONMATCH_SHOW.category,
              gaParams.SEPARATED_FROMPACKAGENODESTINATIONMATCH_SHOW.eventType,
              searchValue,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS_FROM_PACKAGE.eventType,
              searchValue,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_DESTINATIONNOTFOUND_SHOW.category,
              gaParams.SEPARATED_DESTINATIONNOTFOUND_SHOW.eventType,
              searchValue,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_COUNTRIES_TAB_ERROR_ON_SEARCH_COUNTRY_BUSINESS.eventType,
              searchValue,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaSelectDatesTabIsClickedBusinessIndividual() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_CLICKED.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_CLICKED.eventType,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_IS_CLICKED.eventParams,
  );
}

export function gaSelectDatesTabIsClicked(activeLobbyTab, isSeparatedSale) {
  switch (activeLobbyTab) {
    case lobbyTabsEnum.PRIVATE:
      gaEvent(
        gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_PRIVATE.category,
        gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_PRIVATE.eventType,
        gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_PRIVATE.eventParams,
      );
      break;
    case lobbyTabsEnum.BUSINESSACCOUNT:
      if (isSeparatedSale) {
        gaEvent(
          gaParams.SEPARATED_DATEDEFINITION_CLICK.category,
          gaParams.SEPARATED_DATEDEFINITION_CLICK.eventType,
          gaParams.SEPARATED_DATEDEFINITION_CLICK.eventParams,
        );
      } else {
        gaEvent(
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_BUSINESS.category,
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_BUSINESS.eventType,
          gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_IS_CLICKED_BUSINESS.eventParams,
        );
      }
      break;
    default:
      break;
  }
}

export function gaStartDateIsSelected(activeLobbyTab, startedFromPackage, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED.eventParams,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE.eventType,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_PRIVATE.eventParams,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_FROMPACKAGESTARTDATE_CLICK.category,
              gaParams.SEPARATED_FROMPACKAGESTARTDATE_CLICK.eventType,
              gaParams.SEPARATED_FROMPACKAGESTARTDATE_CLICK.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE.eventType,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE.eventParams,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(
              gaParams.SEPARATED_STARTDATE_CLICK.category,
              gaParams.SEPARATED_STARTDATE_CLICK.eventType,
              gaParams.SEPARATED_STARTDATE_CLICK.eventParams,
            );
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS.eventType,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_START_DATE_IS_SELECTED_BUSINESS.eventParams,
            );
          }
        }
        break;
      default:
        break;
    }
  }
}

export function gaEndDateIsSelected(activeLobbyTab, startedFromPackage, isSeparatedSale, isBusinessIndividual, daysCount) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED.eventType,
      daysCount,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        if (startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE_FROM_PACKAGE.eventType,
            daysCount,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE.category,
            gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_PRIVATE.eventType,
            daysCount,
          );
        }

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (startedFromPackage) {
          if (isSeparatedSale) {
            gaEvent(gaParams.SEPARATED_FROMPACKAGEENDDATE_CLICK.category, gaParams.SEPARATED_FROMPACKAGEENDDATE_CLICK.eventType, daysCount);
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS_FROM_PACKAGE.eventType,
              daysCount,
            );
          }
        } else {
          if (isSeparatedSale) {
            gaEvent(gaParams.SEPARATED_ENDDATE_CLICK.category, gaParams.SEPARATED_ENDDATE_CLICK.eventType, daysCount);
          } else {
            gaEvent(
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS.category,
              gaParams.ABROAD_LOBBY_SELECT_DATES_TAB_END_DATE_IS_SELECTED_BUSINESS.eventType,
              daysCount,
            );
          }
        }

        break;
      default:
        break;
    }
  }
}
export function gaSearchPackagesPartanyResult(withParams) {
  if (withParams) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_WITH_PARAMETERS.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_WITH_PARAMETERS.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS_WITH_PARAMETERS.eventParams,
    );
  } else {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_SEARCH_PACKAGES_RESULTS.eventParams,
    );
  }
}

export function gaSearchPackagesResult(activeLobbyTab, count, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN.eventParams,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gaEvent(
          gaParams.ABROAD_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN_PRIVATE.category,
          gaParams.ABROAD_LOBBY_SEARCHED_PACKAGES_ARE_SHOWN_PRIVATE.eventType,
          count,
        );
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (isSeparatedSale) {
          gaEvent(gaParams.SEPARATED_SEARCHRESULTS_SHOW.category, gaParams.SEPARATED_SEARCHRESULTS_SHOW.eventType, count);
        } else {
          gtag4({
            event: 'CellcomAbroad_Step3_SearchResults',
            title: count + ' חבילות',
            step: '3',
            action: 'SearchResults',
            process_type: 'business',
            funnel_name: '2 - SearchArea - Business',
          });
        }
        break;
      default:
        break;
    }
  }
}
export function gaToggleValidyButNotExactbutton(activeLobbyTab, isSeparatedSale, businessIndividual) {
  if (businessIndividual) {
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gtag4({
          event: 'CellcomAbroad_Step4_MorePackagesButtonNotRelatedToSearch',
          button: 'תרצו לראות עוד חבילות?',
          step: '4',
          action: 'MorePackagesButtonNotRelatedToSearch',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
        });

        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_LESSFITTINGPACKAGES_CLICK.category,
            gaParams.SEPARATED_LESSFITTINGPACKAGES_CLICK.eventType,
            gaParams.SEPARATED_LESSFITTINGPACKAGES_CLICK.eventParams,
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step5_MorePackagesButtonNotRelatedToSearch',
            button: 'תרצו לראות עוד חבילות?',
            step: '5',
            action: 'MorePackagesButtonNotRelatedToSearch',
            process_type: 'business',
            funnel_name: '2 - SearchArea - Business',
          });
        }
        break;
      default:
        break;
    }
  }
}

export function gaOrderingButtonClick(selectedPackage, activeLobbyTab, isSeparatedSale, isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCHED_PURCHASE_BUTTON_IS_CLICKED.eventParams,
    );
  } else {
    switch (activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gtag4({
          event: 'CellcomAbroad_Step5_PackageCtaClick',
          button: selectedPackage?.buttonValue,
          package_name: selectedPackage?.titleEpi,
          badge: selectedPackage?.tagTextSecondary,
          title: selectedPackage?.titleEpi,
          content: selectedPackage?.textUnderPackage,
          step: '5',
          action: 'PackageCtaClick',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
        });
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_SEARCHPACKAGEBUY_CLICK.category,
            gaParams.SEPARATED_SEARCHPACKAGEBUY_CLICK.eventType,
            gaParams.SEPARATED_SEARCHPACKAGEBUY_CLICK.eventParams,
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step6_SearchResultsPackageContinueButton',
            button: selectedPackage?.buttonValue,
            package_name: selectedPackage?.titleEpi,
            badge: selectedPackage?.tagTextSecondary,
            title: selectedPackage?.titleEpi,
            content: selectedPackage?.textUnderPackage,
            step: '6',
            action: 'SearchResultsPackageContinueButton',
            process_type: 'business',
            funnel_name: '2 - SearchArea - Business',
          });
        }
        break;
      default:
        break;
    }
  }
}

export function gaPackagesEmptyResult(isBusinessIndividual) {
  if (isBusinessIndividual) {
    gaEvent(
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT.category,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT.eventType,
      gaParams.ABROAD_BUSINESS_INDIVIDUAL_LOBBY_SEARCH_EMPTY_RESULT.eventParams,
    );
  }
}
export function gaDefaultPackageContinueWithSelected(businessOrPrivate, startedFromPackage, buttonText) {
  switch (businessOrPrivate) {
    case customerTypeEnum.PRIVATE:
      if (startedFromPackage) {
        gaEvent(
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.category,
          gaParams.ABROAD_TICKET_DEFAULT_PACKAGE_POPUP_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.eventType,
          buttonText,
        );
      } else {
        gtag4({
          event: 'CellcomAbroad_Step13_DefaultPackageClickButton',
          step: '13',
          action: 'DefaultPackageClickButton',
          process_type: 'private',
          funnel_name: '2 - SearchArea',
          button: buttonText,
        });
      }
      break;
    case customerTypeEnum.BUSINESS:
      if (!startedFromPackage) {
        gtag4({
          event: 'CellcomAbroad_Step7_DefaultRoamingPackageButton',
          step: '7',
          button: buttonText,
          action: 'DefaultRoamingPackageButton',
          process_type: 'business',
          funnel_name: '1 - Lobby - Business',
        });
      }
      break;
    default:
      return null;
  }
}

export function gaSockRoamButtonClick(buttonText) {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP_BUTTON_CLICK_ACTION.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_SOC_ROAM_POPUP_BUTTON_CLICK_ACTION.eventType,
    buttonText,
  );
}

export function gaChangeAccountAutoPackage() {
  gaEvent(
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP_BUTTON.category,
    gaParams.ABROAD_BUSINESS_INDIVIDUAL_TICKET_AUTO_PACKAGE_POPUP_BUTTON.eventType,
    'לבחירת מנוי אחר',
  );
}

export function gaHiddenPackagesContainer() {
  gaEvent(
    gaParams.ABROAD_MY_ABROAD_BUSINESS_INDIVIDUAL_HIDDEN_PACKAGES_MSG.category,
    gaParams.ABROAD_MY_ABROAD_BUSINESS_INDIVIDUAL_HIDDEN_PACKAGES_MSG.eventType,
    gaParams.ABROAD_MY_ABROAD_BUSINESS_INDIVIDUAL_HIDDEN_PACKAGES_MSG.eventParams,
  );
}

export function gaAutoPackagesContainer(soc) {
  gaEvent(gaParams.ABROAD_MY_ABROAD_AUTO_PACKAGES_ARE_SHOWN.category, gaParams.ABROAD_MY_ABROAD_AUTO_PACKAGES_ARE_SHOWN.eventType, soc);
}
